document.addEventListener('click', function (e) {
  var btn = e.target.closest('.lv-qty-btn');
  if (!btn) return;
  var input = btn.parentNode.querySelector('input.quantity-input');
  if (!input) return;
  var before = input.value;
  if (btn.dataset.lvQty === '1') { input.stepUp(); } else { input.stepDown(); }
  if (input.value !== before) {
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener('click', function (e) {
  var btn = e.target.closest('.lv-discount-apply');
  if (!btn) return;
  var field = btn.closest('cart-discount-field');
  var input = field && field.querySelector('input:not([type="hidden"])');
  if (!input) return;
  if (!input.value.trim()) { input.focus(); return; }
  input.blur();
});

(function () {
  function init() {
    var fab = document.querySelector('.lv-fab-cart');
    if (!fab || !('IntersectionObserver' in window)) return;
    var atc = [].slice.call(document.querySelectorAll('button[type="submit"]')).filter(function (b) {
      return b.form && /\/cart\/add/.test(b.form.getAttribute('action') || '') &&
        !b.closest('product-card, .product-card, .horizontal-product, cart-drawer, quick-buy-drawer, product-quick-add, .product-quick-add, .shopify-payment-button');
    })[0];
    if (!atc) return;
    fab.hidden = false;
    new IntersectionObserver(function (entries) {
      fab.classList.toggle('is-visible', !entries[0].isIntersecting && !atc.disabled);
    }).observe(atc);
    if (!fab.hasAttribute('data-drawer')) {
      fab.addEventListener('click', function () { atc.click(); });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();